import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BlindTest } from 'src/@types/api-types';
import { blindTestInitialState } from './constants';

const blindTestSlice = createSlice({
  name: 'blindTest',
  initialState: blindTestInitialState,
  reducers: {
    setBlindTest: (state, action: PayloadAction<BlindTest>) => {
      state.blindTest = action.payload;
    },
  },
});

export const { setBlindTest } = blindTestSlice.actions;

export default blindTestSlice.reducer;
